export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English", icon: "flag-icon-us" },
  { id: "ja", name: "Japanese", icon: "flag-icon-jp" },
];
